const deleteDialogTypes = {
  deleteCourt: "Ви впевнені, що хочете видалити цей майданчик?",
  deletePost: "Ви впевнені, що хочете видалити цей пост?",
  deleteAdmin: "Ви впевнені, що хочете видалити цього адміна?",
  closeCourt:
    "Зміни не збережено. Ви впевнені, що хочете закрити цей майданчик?",
  adminLogout: "Ви впевнені, що хочете вийти з адміністрації?",
};

export default deleteDialogTypes;
